import echarts from 'echarts';

export function initDepth(depthData, type) {
    const rawDepthData = depthData;
    let _rawDepthData = null;
    if (type == '1' || !_rawDepthData) {
        _rawDepthData = rawDepthData;
    }
    const myChart = echarts.init(document.getElementById('div_depth'));
    const times = [];
    const xAsks = [];
    const yAsks = [];
    const xBids = [];
    const yBids = [];

    // asks卖单，bids买单

    let i;
    let bidsTotal = 0;
    let asksTotal = 0;

    if (typeof rawDepthData.bids !== 'undefined') {
        rawDepthData.bids = rawDepthData.bids.slice(0, 30);
        for (i = rawDepthData.bids.length - 1; i >= 0; i -= 1) {
            times.push(rawDepthData.bids[i].price);
            bidsTotal += parseFloat(rawDepthData.bids[i].realAmount);
        }
    }

    if (typeof rawDepthData.asks !== 'undefined') {
        // console.log("asks:");
        // console.log(rawDepthData.asks.length);
        // if (rawDepthData.asks.length > 30) {
        rawDepthData.asks = rawDepthData.asks.slice(0, 30);
        // }
        for (i = 0; i < rawDepthData.asks.length; i += 1) {
            times.push(rawDepthData.asks[i].price);
        }
    }
    if (typeof rawDepthData.bids !== 'undefined') {
        for (i = rawDepthData.bids.length - 1; i >= 0; i -= 1) {
            xBids.push(rawDepthData.bids[i].price);
            yBids.push(bidsTotal);
            bidsTotal -= parseFloat(rawDepthData.bids[i].realAmount);
            if (bidsTotal < 0) {
                bidsTotal = 0;
            }
        }
    }
    if (typeof rawDepthData.asks !== 'undefined') {
        for (i = 0; i < rawDepthData.asks.length; i += 1) {
            xAsks.push(rawDepthData.asks[i].price);
            asksTotal += parseFloat(rawDepthData.asks[i].realAmount);
            yAsks.push(asksTotal);
        }
    }
    if (yAsks[yAsks.length - 1] < yBids[0]) {
        yAsks.push(yBids[0]);
    } else {
        yBids.push(yAsks[yAsks.length - 1]);
    }

    // yBids[yBids.length-1]='1';
    // xBids[xBids.length-1]='0';
    // console.log(xAsks);
    // console.log(yAsks);
    // console.log(xBids);
    // console.log(yBids);
    const option = {
        backgroundColor: '#171B2B',
        xAxis: [
            {
                type: 'category',
                data: times,
                scale: true,
                axisLine: {
                    lineStyle: { color: '#aeb2c3' },
                },
                boundaryGap: ['20%', '20%'],
                axisPointer: {
                    label: {
                        show: true,
                        interval: 2,
                    },
                },
                zlevel: 99,
            },
            {
                type: 'category',
                gridIndex: 1,

                data: xAsks,
                min: 'dataMin',
                axisTick: false,
                axisLabel: false,
                zlevel: 0,
                axisLine: { show: false },
            },
            {
                type: 'category',

                gridIndex: 2,
                data: xBids,
                min: 'dataMin',
                axisTick: false,
                axisLabel: false,
                zlevel: 0,
            },
        ],
        yAxis: [
            {
                position: 'right',
                scale: true,
                boundaryGap: ['20%', '20%'],
                axisLabel: {
                    showMinLabel: false,
                    showMaxLabel: false,
                },
                zlevel: 1,
            },
            {
                position: 'right',
                scale: true,
                step: true,
                gridIndex: 1,
                splitNumber: 3,
                boundaryGap: ['30%', 0],
                axisTick: { inside: true },
                axisLabel: false,
                splitLine: false,
                min: 'dataMin',
                zlevel: 0,
            },
            {
                position: 'left',
                scale: true,
                step: true,
                gridIndex: 2,
                splitNumber: 3,
                boundaryGap: [0, 0],
                axisTick: { inside: true },
                axisLabel: false,
                splitLine: false,
                max: 'dataMax',
                zlevel: 2,
            },
        ],
        grid: [
            {
                bottom: '25',
                left: '0',
                right: '0',
                height: '0',
            },
            {
                bottom: '24',
                left: '50%',
                width: '50%',
                height: '100%',
            },
            {
                bottom: '24',
                left: '0%',
                width: '50%',
                height: '100%',
            },
        ],
        tooltip: {
            trigger: 'axis',
            formatter() {
                return '';
            },
            textStyle: {
                color: '#000000',
            },
            backgroundColor: 'transparent',
            padding: [0, 0],
            position: [3, 3],
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    type: 'solid',
                },
            },
        },
        axisPointer: {
            zlevel: 2,
        },
        series: [
            {
                name: 'Asks',
                type: 'line',
                xAxisIndex: 1,
                yAxisIndex: 1,
                data: yAsks,
                showSymbol: false,
                animation: false,
                lineStyle: {
                    normal: {
                        width: 1,
                        color: '#44293b',
                    },
                },
                areaStyle: {
                    normal: {
                        color: '#44293b',
                    },
                },
            },
            {
                name: 'Bids',
                type: 'line',
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: yBids,
                showSymbol: false,
                animation: false,
                lineStyle: {
                    normal: {
                        width: 0,
                        color: '#334c50',
                    },
                },
                areaStyle: {
                    normal: {
                        color: '#334c50',
                    },
                },
            },
        ],
    };
    myChart.setOption(option);
}

export function replaceDepthData(_data, data) {
    const oldData = _data;
    const bidsMap = {};
    if (data.bids) {
        let bidsNull = true;
        for (let i = 0; i < data.bids.length; i += 1) {
            bidsMap[data.bids[i][0]] = data.bids[i][1];
            bidsNull = false;
        }
        if (!bidsNull) {
            for (let i = 0; i < oldData.bids.length; i += 1) {
                if (bidsMap[oldData.bids[i][0]]) {
                    oldData.bids[i][1] = bidsMap[oldData.bids[i][0]];
                }
            }
        } else {
            oldData.bids = data.bids;
        }
    }
    if (data.asks) {
        const asksMap = {};
        let asksNull = true;
        for (let i = 0; i < data.asks.length; i += 1) {
            asksMap[data.asks[i][0]] = data.asks[i][1];
            asksNull = true;
        }
        if (!asksNull) {
            for (let i = 0; i < oldData.asks.length; i += 1) {
                if (asksMap[oldData.asks[i][0]]) {
                    oldData.asks[i][1] = bidsMap[oldData.asks[i][0]];
                }
            }
        } else {
            oldData.asks = data.asks;
        }
    }
    return oldData;
}

function mysort(a, b, sortType) {
    if (sortType == 0) {
        return parseFloat(a) < parseFloat(b);
    }
    return parseFloat(a) > parseFloat(b);
}

function merge(_data, data, isclear, sortType) {
    const bids = [];
    const nbids = [];
    for (let i = 0; i < data.length; i += 1) {
        nbids.push(data[i]);
    }

    for (let i = 0; i < nbids.length; i += 1) {
        for (let j = i + 1; j < nbids.length; j += 1) {
            // if (nbids[i][0] < nbids[j][0]) {
            if (mysort(nbids[i][0], nbids[j][0], sortType)) {
                const t = nbids[i];
                nbids[i] = nbids[j];
                nbids[j] = t;
            }
        }
    }
    if (isclear) {
        for (let i = 0; i < nbids.length; i += 1) {
            if (nbids[i][1] > 0) {
                bids.push(nbids[i]);
            }
        }
    } else {
        let i = 0;
        let j = 0;
        while (i < nbids.length && j < _data.length) {
            if (nbids[i][0] == _data[j][0]) {
                if (parseFloat(nbids[i][1]) > 0) {
                    bids.push(nbids[i]);
                }
                i += 1;
                j += 1;
            } else if (mysort(nbids[i][0], _data[j][0], sortType)) {
                if ((parseFloat(_data[j][1])) > 0) {
                    bids.push(_data[j]);
                }
                j += 1;
            } else {
                if (parseFloat(nbids[i][1]) > 0) {
                    bids.push(nbids[i]);
                }
                i += 1;
            }
        }
        while (i < nbids.length) {
            if (parseFloat(nbids[i][1]) > 0) {
                bids.push(nbids[i]);
            }
            i += 1;
        }


        while (j < _data.length) {
            if (parseFloat(_data[j][1]) > 0) {
                bids.push(_data[j]);
            }
            j += 1;
        }
    }

    return bids;
}
export function replaceDepthNew(_data, data, isclear) {
    let bids = [];
    let asks = [];
    const obj = {};
    if (data.bids) {
        bids = merge(_data.bids.map((item) => {
            if (item.price) {
                return [item.price, item.realAmount];
            }
            return item;
        }), data.bids, isclear, 0);
        obj.bids = bids;
    } else if (_data.bids && !isclear) {
        obj.bids = _data.bids;
    }

    if (data.asks) {
        asks = merge(_data.asks.map((item) => {
            if (item.price) {
                return [item.price, item.realAmount];
            }
            return item;
        }), data.asks, isclear, 0);
        obj.asks = asks;
    } else if (_data.asks && !isclear) {
        obj.asks = _data.asks;
    }
    return obj;
}


export function getDepthList(prec) {
    const depthList = Array(
        ...{
            length: (prec - 2) + 1,
        },
    ).map(
        (v, i) =>
            `0.${Array.apply('0', { length: i + 2 }).join(
                '0',
            )}1`,
    ).reverse();
    return depthList;
}
export function getDepth(market, prec) {
    const localDepth = localStorage.getItem(`${market.id}depth`) || undefined;
    const pricePrec = localDepth ? localDepth.length - 2 : prec;
    const depth = `0.${Array(...{ length: pricePrec - 1 })
        .map(() => '0')
        .join('')}1`;

    return depth;
}



// WEBPACK FOOTER //
// ./src/utils/depth.js